
(() => {
  const flavours = [
    ['True Red', 'True Red · red velvet com recheio de Nutella'],
    ['Russet', 'Russet · brownie com recheio de creme Lotus'],
    ['Tan', 'Tan · blondie com recheio de creme KITKAT®'],
    ['Violete', 'Violete · blondie com recheio de caramelo e amêndoas']
  ];
  const formatter = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' });
  function fillFlavours(container, count, prefix) {
    container.replaceChildren();
    for (let i = 1; i <= count; i++) {
      const field = document.createElement('div'); field.className = 'bp-field';
      const label = document.createElement('label'); label.htmlFor = prefix + '-' + i; label.textContent = 'BONUM ' + i;
      const select = document.createElement('select'); select.id = label.htmlFor; select.name = 'properties[Sabor ' + i + ']'; select.required = true;
      select.add(new Option('Escolha o recheio', '', true, true)); select.options[0].disabled = true;
      for (const [value, text] of flavours) select.add(new Option(text, value));
      field.append(label, select); container.append(field);
    }
  }

  function variantMask(title) {
    const value = String(title).toLocaleLowerCase('pt-PT');
    return (value.includes('palitos premium') ? 1 : 0) | (value.includes('laços') ? 2 : 0) | (value.includes('caixa premium') ? 4 : 0);
  }
  function configureOrder(form, count, rawVariants) {
    const variants = JSON.parse(rawVariants);
    form._bpOrder = { count, variants };
    const note = form.querySelector('[data-bp-dedication]');
    if (note) note.value = '';
    const requested = form.matches('[data-bp-direct-form]') ? variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant')) : null;
    const requestedMask = requested ? variantMask(requested.title) : 0;
    form.querySelectorAll('[data-bp-extra]').forEach(input => { input.checked = !!(requestedMask & Number(input.dataset.bpExtra)); });
    function update() {
      const state = form._bpOrder;
      const mask = Array.from(form.querySelectorAll('[data-bp-extra]')).reduce((sum, input) => sum | (input.checked ? Number(input.dataset.bpExtra) : 0), 0);
      const variant = state.variants.find(v => variantMask(v.title) === mask);
      const submit = form.querySelector('[data-bp-submit]');
      const total = form.querySelector('[data-bp-total]');
      const id = form.querySelector('[name=id]');
      if (!variant) {
        id.value = ''; total.textContent = 'Opção indisponível'; submit.disabled = true; return;
      }
      id.value = String(variant.id);
      total.textContent = formatter.format(Number(variant.price) / 100);
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Adicionar ao carrinho' : 'Disponível em breve';
      form.querySelectorAll('[data-bp-extra-cost]').forEach(label => {
        const bit = Number(label.dataset.bpExtraCost);
        const cents = bit === 1 ? state.count * 35 : bit === 2 ? state.count * 25 : 100;
        label.textContent = '+' + formatter.format(cents / 100);
      });
      const dedication = form.querySelector('[data-bp-dedication]');
      if (dedication) {
        dedication.value = dedication.value.slice(0, 250);
        form.querySelector('[data-bp-character-count]').textContent = dedication.value.length + ' / 250';
      }
    }
    form._bpRefreshOrder = update;
    if (!form.dataset.bpOrderBound) {
      form.dataset.bpOrderBound = 'true';
      form.addEventListener('change', () => form._bpRefreshOrder());
      form.addEventListener('input', () => form._bpRefreshOrder());
      form.addEventListener('submit', event => {
        form._bpRefreshOrder();
        if (form.querySelector('[data-bp-submit]').disabled) event.preventDefault();
      });
    }
    update();
  }

  function init(root) {
    if (root.dataset.bpReady) return; root.dataset.bpReady = 'true';
    const track = root.querySelector('[data-bp-track]');
    if (track) {
      root.querySelectorAll('[data-bp-scroll]').forEach(button => button.addEventListener('click', () => {
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: Number(button.dataset.bpScroll) * track.clientWidth * .85, behavior: reduced ? 'instant' : 'smooth' });
      }));
    }
    if (track) {
      let scheduled = false;
      function progress() {
        const cards = Array.from(track.querySelectorAll('[data-bp-card]'));
        const left = track.getBoundingClientRect().left;
        let index = 0, distance = Infinity;
        cards.forEach((card, i) => { const d = Math.abs(card.getBoundingClientRect().left - left); if (d < distance) { distance = d; index = i; } });
        const label = root.querySelector('[data-bp-progress]');
        if (label) label.textContent = String(index + 1).padStart(2, '0') + ' / ' + cards.length;
        scheduled = false;
      }
      track.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(progress); } }, { passive: true });
      progress();
    }
    const dialog = root.querySelector('[data-bp-detail-dialog]');
    let opener;
    root.querySelectorAll('[data-bp-open]').forEach(button => button.addEventListener('click', () => {
      const card = button.closest('[data-bp-card]'); opener = button;
      const count = Number(card.dataset.count);
      dialog.querySelector('form').reset();
      const image = dialog.querySelector('[data-bp-photo]'); image.src = card.dataset.image; image.alt = card.dataset.title + ', conjunto de ' + count + ' BONUM';
      dialog.querySelector('[data-bp-title]').textContent = card.dataset.title;
      dialog.querySelector('[data-bp-count]').textContent = count + ' BONUM · conjunto fixo como na fotografia';
      dialog.querySelector('[data-bp-price]').textContent = formatter.format(Number(card.dataset.price));
      dialog.querySelector('[name=id]').value = card.dataset.variant;
      dialog.querySelector('[name="properties[Modelo]"]').value = card.dataset.title;
      dialog.querySelector('[name="properties[Unidades do conjunto]"]').value = String(count);
      fillFlavours(dialog.querySelector('[data-bp-flavours]'), count, 'bp-flavour-' + card.dataset.code);
      configureOrder(dialog.querySelector('form'), count, card.dataset.variants);
      dialog.showModal();
    }));
    root.querySelectorAll('dialog').forEach(d => {
      d.querySelectorAll('[data-bp-close]').forEach(b => b.addEventListener('click', () => d.close()));
      d.addEventListener('close', () => { if (opener) opener.focus(); });
    });
    const direct = root.querySelector('[data-bp-direct-form]');
    if (direct) {
      const count = Number(direct.dataset.count);
      fillFlavours(direct.querySelector('[data-bp-flavours]'), count, 'bp-direct-flavour');
      configureOrder(direct, count, direct.dataset.variants);
    }
    const idea = root.querySelector('[data-bp-idea-dialog]');
    root.querySelectorAll('[data-bp-idea-open]').forEach(button => button.addEventListener('click', () => { opener = button; idea.showModal(); }));
    if (idea) {
      const form = idea.querySelector('form');
      const date = form.elements.namedItem('deliveryDate');
      function isClosed(value) { return /^\d{4}-\d{2}-\d{2}$/.test(value) && ['12-25','01-01'].includes(value.slice(5)); }
      function validateDate() { date.setCustomValidity(isClosed(date.value) ? 'Não realizamos entregas nem recolhas a 25 de dezembro e 1 de janeiro. Escolha outra data.' : ''); }
      function minimumDate() {
        const now = new Date();
        const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Lisbon', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
        const get = type => Number(parts.find(p => p.type === type).value);
        const d = new Date(Date.UTC(get('year'), get('month') - 1, get('day') + 1));
        while (isClosed(d.toISOString().slice(0, 10))) d.setUTCDate(d.getUTCDate() + 1);
        return d.toISOString().slice(0, 10);
      }
      date.min = minimumDate();
      function summary() {
        const fd = new FormData(form);
        return ['Olá, BONUM! Gostaria de pedir um orçamento para a minha ideia.',
          'Nome: ' + (fd.get('customerName') || ''),
          'Ideia / tema: ' + (fd.get('idea') || ''),
          'Quantidade: ' + (fd.get('units') || '') + ' BONUM',
          'Data de entrega pretendida: ' + (fd.get('deliveryDate') || ''),
          'Entrega / recolha: ' + (fd.get('delivery') || ''),
          'Pedido de orçamento, sujeito a confirmação de disponibilidade e preço.'].join('\n');
      }
      function refresh() { validateDate(); idea.querySelector('[data-bp-summary]').textContent = summary(); }
      form.addEventListener('input', refresh); refresh();
      form.addEventListener('submit', event => {
        event.preventDefault(); date.min = minimumDate(); validateDate();
        if (!form.reportValidity()) return;
        window.location.assign('https://wa.me/351929141618?text=' + encodeURIComponent(summary()));
      });
    }
  }
  document.querySelectorAll('[data-bp-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-bp-root]').forEach(init));
})();
